import types from './mutation-types';
import store from '@/store';
import { isNil, uniq, merge, pick } from 'lodash';

class Breadcrumb {

	constructor(routePath, router) {
		this.router = router;
		return this.build(routePath);
	}

	build(routePath) {
		const url = this.parseUrl(routePath);

		const possibleRoutes = this.createPossibilities(url);

		const routes = possibleRoutes
			.map(routeUrl => {
				return pick(this.router.match(routeUrl), [
					'fullPath',
					'hash',
					'meta',
					'name',
					'params',
					'path',
					'query'
				]);
			})
			.filter(route => !isNil(route.name));

		return uniq(routes);
	}

	parseUrl(routePath) {
		return (routePath == '/') ? routePath : routePath.replace(/\/$/, '');
	}

	createPossibilities(url) {
		const possibleRoutes = [];

		while (url.length > 1) {
			possibleRoutes.unshift(url);

			if (url.indexOf('/') == -1) {
				url = '';
			} else {
				url = url.substring(0, url.lastIndexOf('/'));
			}
		}

		return possibleRoutes;
	}
}

const state = {
	routes: []
};

const actions = {
	nextPage({ commit }, { to, from, router }) {
		commit(types.SET_BREADCRUMB, new Breadcrumb(to.fullPath, router));
	},
	mergeBreadcrumb({ commit }, breadcrumb) {
		commit(types.MERGE_BREADCRUMB, breadcrumb);
	},
	setBreadcrumb({ commit }, breadcrumb) {
		commit(types.SET_BREADCRUMB, breadcrumb);
	}
};

const getters = {
	get: state => state.routes,
	getFormatted: state => state.routes.map((route) => ({
		text: (route.meta.title) ? route.meta.title : route.name,
		to: route.fullPath
	}))
};

const mutations = {
	[types.SET_BREADCRUMB](state, payload) {
		state.routes = payload;
	},
	[types.MERGE_BREADCRUMB](state, payload) {
		state.routes = merge(state.routes, payload);
	}
};

export const hookBreadcrumpAtRouter = (router) => {
	router.beforeEach((to, from, next) => {
		store.dispatch('breadcrumb/nextPage', { to: to, from: from, router: router });
		next();
	})
}

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/breadcrumb/index.js